/* eslint no-inline-comments: 0 */

// The Network rules tab of Classification rules (../classification_rules/).
// These are the tab's child routes, mounted under `classification-rules/`;
// the parent route and its tab bar live in ../classification_rules/_routes.js.

const Overview = () => import( /* webpackChunkName: "group-network-rules" */ `./network-overview.vue` );
const Sources = () => import( /* webpackChunkName: "group-network-rules" */ `./sources-list.vue` );
const SourceUpsert = () => import( /* webpackChunkName: "group-network-rules" */ `./source-upsert.vue` );
const Rules = () => import( /* webpackChunkName: "group-network-rules" */ `./rules-list.vue` );
const RuleAdd = () => import( /* webpackChunkName: "group-network-rules" */ `./rule-add.vue` );
const ASNs = () => import( /* webpackChunkName: "group-network-rules" */ `./asn-browser.vue` );
const UARules = () => import( /* webpackChunkName: "group-network-rules" */ `./ua-rules.vue` );
const UARuleUpsert = () => import( /* webpackChunkName: "group-network-rules" */ `./ua-rule-upsert.vue` );

export const network_children = [
	{
		path: `network`,
		name: `classification-rules-network`,
		component: Overview,
		meta: {
			title: `Classification rules: Network rules`
		}
	},
	{
		path: `network/sources`,
		name: `classification-rules-network-sources`,
		component: Sources,
		meta: {
			title: `Network rules: Vendors & lists`
		}
	},
	{
		path: `network/sources/new`,
		name: `classification-rules-network-source-add`,
		component: SourceUpsert,
		meta: {
			title: `Add Source`
		}
	},
	{
		path: `network/sources/:key`,
		name: `classification-rules-network-source-edit`,
		component: SourceUpsert,
		meta: {
			title: `Edit Source`
		}
	},
	{
		path: `network/rules`,
		name: `classification-rules-network-rules`,
		component: Rules,
		meta: {
			title: `Network rules: Prefix, ASN & Account rules`
		}
	},
	{
		path: `network/rules/new`,
		name: `classification-rules-network-rule-add`,
		component: RuleAdd,
		meta: {
			title: `Add Rule`
		}
	},
	{
		path: `network/asns`,
		name: `classification-rules-network-asns`,
		component: ASNs,
		meta: {
			title: `Network rules: ASN browser`
		}
	},
	{
		path: `network/ua-rules`,
		name: `classification-rules-network-ua-rules`,
		component: UARules,
		meta: {
			title: `Network rules: User agent rules`
		}
	},
	{
		path: `network/ua-rules/new`,
		name: `classification-rules-network-ua-rule-add`,
		component: UARuleUpsert,
		meta: {
			title: `Add User Agent Rule`
		}
	},
	{
		path: `network/ua-rules/:uuid`,
		name: `classification-rules-network-ua-rule-edit`,
		component: UARuleUpsert,
		meta: {
			title: `Edit User Agent Rule`
		}
	}
];

// The routes this page had before it became a tab. The names and paths keep
// resolving, and send you to the same page under Classification rules.
function to( name, keep_params = false ) {
	return route => ( {
		name,
		params: keep_params ? route.params : {}
	} );
}

export const network_legacy_routes = {
	path: `network-rules`,
	children: [
		{
			path: ``,
			name: `list-network-rules`,
			redirect: to( `classification-rules-network` )
		},
		{
			path: `sources`,
			name: `network-rules-sources`,
			redirect: to( `classification-rules-network-sources` )
		},
		{
			path: `sources/new`,
			name: `add-network-rules-source`,
			redirect: to( `classification-rules-network-source-add` )
		},
		{
			path: `sources/:key`,
			name: `edit-network-rules-source`,
			redirect: to( `classification-rules-network-source-edit`, true )
		},
		{
			path: `rules`,
			name: `network-rules-rules`,
			redirect: to( `classification-rules-network-rules` )
		},
		{
			path: `rules/new`,
			name: `add-network-rules-rule`,
			redirect: to( `classification-rules-network-rule-add` )
		},
		{
			path: `asns`,
			name: `network-rules-asns`,
			redirect: to( `classification-rules-network-asns` )
		},
		{
			path: `ua-rules`,
			name: `network-rules-ua-rules`,
			redirect: to( `classification-rules-network-ua-rules` )
		},
		{
			path: `ua-rules/new`,
			name: `add-network-rules-ua-rule`,
			redirect: to( `classification-rules-network-ua-rule-add` )
		},
		{
			path: `ua-rules/:uuid`,
			name: `edit-network-rules-ua-rule`,
			redirect: to( `classification-rules-network-ua-rule-edit`, true )
		}
	]
};
